const MichaelRowTheBoatAshore = [
	'Michael row the boat ashore, Hallelujah',
	'Michael row the boat ashore, Hallel u jah',
	'',
	'Sister help to trim the sails, Hallelujah',
	'Sister help to trim the sails, Hallel u jah',
	'',
	'Michael row the boat ashore, Hallelujah',
	'Michael row the boat ashore, Hallel u jah',
	'',
	'River Jordon is chilly and cold, Hallelujah',
	'Chills the body but not the soul, Hallel u jah',
	'',
	'Michael row the boat ashore, Hallelujah',
	'Michael row the boat ashore, Hallel u jah',
	'',
	'River is deep and the river is wide, Hallelujah',
	'Milk and honey on the other side, Hallel u jah',
	'',
	'Michael row the boat ashore, Hallelujah',
	'Michael row the boat ashore, Hallel u jah',
];

export default MichaelRowTheBoatAshore;
